import { Spinner, Text } from "@fluentui/react-components";

export const LoadingSpinner = (): JSX.Element => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100dvh",
        width: "100%",
        backgroundColor: "white",
      }}
    >
      <Spinner size="huge" style={{ marginBottom: "20px" }} />
      <Text size={600} weight="bold">
        {sessionStorage.getItem("app") === "project-iq" ||
        window.location.hostname.includes("projectiq")
          ? "Loading Project IQ..."
          : "Loading NH AIMS..."}
      </Text>
    </div>
  );
};
